import ScheduleTable from '@bookings/components/tables/schedule-table/schedule-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-schedules',
  components: {
    'bpc-schedule-table': ScheduleTable,
  },
})
export default class Schedules extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
